var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M1.25977 0.740234L7.14212 5.94147L1.25977 11.1427",
    stroke: "#0E2B63",
    strokeWidth: 1.17647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowBlue);
export default __webpack_public_path__ + "static/media/downarrow-blue.fda80f08007bdfd847898b7d7a0e0135.svg";
export { ForwardRef as ReactComponent };